/**
 * Phần thuần của việc dời lịch / mở tờ chi tiết trên màn Lịch (vòng sửa 3.1 — booking-logic-auditor soát 780fd94).
 *
 * Màn Lịch tự tải lại mỗi 60 giây nên bảng có thể đổi dưới tay người bấm: một thao tác phải (a) nhận ra lịch đúng
 * bằng `itemId` (lịch nhiều dịch vụ có nhiều dòng cùng `appointmentId`), (b) mang theo ảnh chụp mà người bấm đã
 * NHÌN THẤY (người · ngày · giờ gốc) để máy chủ từ chối nếu máy khác đã đổi (409 `LICH_VUA_DOI`), (c) khi hoàn
 * tác thì về ĐÚNG ngày gốc chứ không phải ngày màn đang xem.
 */
import type { DayAppointment, DayBoard } from './api.ts'
import type { BaoKhach } from './bao-khach.ts'

/** Thân `POST /v1/admin/appointments/:id/doi-gio`. */
export interface ThanDoiGio {
  date: string
  startMin: number
  staffId: string
  tuStaffId?: string
  tuDate?: string
  tuStartMin?: number
}

export interface ChoLich {
  date: string
  staffId: string
  startMin: number
}

/** Lịch vừa dời: `tu` = chỗ cũ (để hoàn tác về), `den` = chỗ mới (ảnh chụp mà lệnh hoàn tác nhìn thấy). */
export interface VuaDoi {
  a: DayAppointment
  tu: ChoLich
  den: ChoLich
  /** K1a: khách được báo bằng cách nào (máy chủ trả; thiếu = không hứa gì). */
  baoKhach?: BaoKhach | undefined
}

/**
 * Tờ chi tiết đang mở luôn hiện bản MỚI NHẤT của lịch đó trong bảng. `daMat` = bảng của ĐÚNG ngày đang xem đã tải
 * mà lịch không còn trong đó (huỷ / không đến / dời sang ngày khác / máy khác đổi): tờ phải nói thật và khoá nút,
 * không hiện trạng thái lỗi thời như còn bấm được.
 */
export function layLichMo(
  chon: DayAppointment | null,
  data: DayBoard | null,
  date: string,
): { lich: DayAppointment | null; daMat: boolean } {
  if (chon === null) return { lich: null, daMat: false }
  if (data === null || data.date !== date) return { lich: chon, daMat: false }
  const moi = data.appointments.find((x) => x.itemId === chon.itemId)
  return moi === undefined ? { lich: chon, daMat: true } : { lich: moi, daMat: false }
}

/** Thân dời lịch từ kéo-thả / tờ Đổi giờ: đích mới + ảnh chụp chỗ cũ của lịch (người, ngày đang xem, giờ). */
export function thanDoiGio(
  a: DayAppointment,
  ngayDangXem: string,
  den: { date: string; staffId: string; startMin: number },
): ThanDoiGio {
  return {
    date: den.date,
    startMin: den.startMin,
    staffId: den.staffId,
    ...(a.staffId === null ? {} : { tuStaffId: a.staffId }),
    tuDate: ngayDangXem,
    tuStartMin: a.startMin,
  }
}

/** Thân hoàn tác: về chỗ cũ (ngày GỐC), nhìn thấy chỗ vừa dời tới — ai dời tiếp sau đó thì máy chủ từ chối. */
export function thanHoanTac(v: VuaDoi): ThanDoiGio {
  return {
    date: v.tu.date,
    startMin: v.tu.startMin,
    staffId: v.tu.staffId,
    tuStaffId: v.den.staffId,
    tuDate: v.den.date,
    tuStartMin: v.den.startMin,
  }
}
